/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-array-index-key */
import { useTranslation } from 'react-i18next';
import { noDp } from '../../../../helpers/helpers';

const TabWriters = ({ result }) => {
  const { t } = useTranslation('other');
  const total = result?.body?.aggregations?.WriterPaymentSum?.value || 0;
  const highestWriter = result?.body?.aggregations?.Writers?.buckets?.[0]?.WriterName?.hits?.hits?.[0]?._source;
  const highestWriterTotal = result?.body?.aggregations?.Writers?.buckets?.[0]?.WriterValues?.value;
  const highestAccount = result?.body?.aggregations?.ArtistAccounts?.buckets?.[0]?.ArtistAccountName?.hits?.hits?.[0]?._source;
  const highestAccountTotal = result?.body?.aggregations?.ArtistAccounts?.buckets?.[0]?.WriterValues?.value;

  // if (pending || !result) {
  //   return (<LoadingSmall />);
  // }

  return (
    <div className="p-4  h-full flex items-start flex-col">
      <h1 className="text-xl font-medium text-sentric-table-text mb-4">{t('other:writers-and-accounts-tab-header')}</h1>

      <div className="bg-sentric-menu-gray p-2 rounded-lg h-14 mb-2 flex w-full items-center justify-items-start">
        <div className=" text-royalty-blue uppercase text-left text-xxxs w-6/12 font-semibold">
          {t('other:total-writer')}
          <br />
          {t('other:earnings')}
          :
        </div>
        <div className="text-royalty-blue uppercase text-left text-base font-semibold w-6/12">
          &pound;
          {noDp(total)}
        </div>

      </div>

      <div className="h-14 mb-2 p-2 flex w-full items-center justify-items-start">
        <div className="text-royalty-blue text-left text-xxs w-8/12 font-semibold">
          {t('other:highest-earning-writer')}
          <br />
          <span className="text-sentric-table-text text-xxs font-bold">
            {highestWriter?.writerFirstName}
            {' '}
            {highestWriter?.writerMiddleName || ''}
            {' '}
            {highestWriter?.writerLastName}
          </span>
        </div>
        <div className="text-sentric-table-text text-xs w-4/12 pl-1">
          &pound;
          {noDp(highestWriterTotal)}
        </div>

      </div>

      <div className="bg-sentric-menu-gray p-2 rounded-lg h-14 mb-2 flex w-full items-center justify-items-start">
        <div className="text-royalty-blue uppercase text-left text-xxxs w-6/12 font-semibold mr-2">
          {t('other:total-account')}
          <br />
          {t('other:earnings')}
          :
        </div>
        <div className="text-royalty-blue uppercase text-left text-base font-semibold w-6/12">
          &pound;
          {noDp(total)}
        </div>
      </div>

      <div className="h-14 mb-2 p-2 flex w-full items-center justify-items-start">
        <div className="text-royalty-blue text-left text-xxxs w-8/12 font-semibold">
          {t('other:highest-earning-account')}
          <br />
          <span className="text-sentric-table-text text-xxs font-bold">

            {highestAccount?.artistAccountName}
          </span>
        </div>
        <div className="text-sentric-table-text text-xs w-4/12 pl-1">
          &pound;
          {noDp(highestAccountTotal)}
        </div>

      </div>

    </div>
  );
};

export default TabWriters;
